import { getProductFormField } from '../utils';
import Component from './ProductFormCustomContentRadioSelect';
import { injectIntl } from 'react-intl';

export default getProductFormField(injectIntl(Component));
